import { PlanMetadataTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const initPaging = createAction(
  '[PlanMetadata] Initialize Paging',
  props<{ planMetadataId: PlanMetadataTypes.PlanMetadataId; offset: number; pageSize: number }>()
);

export const initPagingIfUnset = createAction(
  '[PlanMetadata] Initialize Paging if Unset',
  props<{ planMetadataId: PlanMetadataTypes.PlanMetadataId; offset: number; pageSize: number }>()
);

export const setOffsetInDesigner = createAction(
  '[PlanMetadata] Set Offset',
  props<{ vizToken: string; planMetadataId: PlanMetadataTypes.PlanMetadataId; offset: number }>()
);

export const resetOffsetInDesigner = createAction(
  '[PlanMetadata] Reset Offset',
  props<{ vizToken: string; planMetadataId: PlanMetadataTypes.PlanMetadataId }>()
);

export const setPageSizeInDesigner = createAction(
  '[PlanMetadata] Set PageSize',
  props<{ vizToken: string; planMetadataId: PlanMetadataTypes.PlanMetadataId; pageSize: number; offset: number }>()
);

export const setOffsetRawResults = createAction(
  '[PlanMetadata] Set Offset Raw Results',
  props<{ queryToken: string; offset: number }>()
);

export const setOffsetWithCalcs = createAction(
  '[PlanMetadata] Set Offset With Calcs',
  props<{ queryToken: string; offset: number }>()
);
